export type LogLevel = 'error' | 'warn' | 'info' | 'debug';

interface Env {
  API_BASE_URL: string;
  APP_NAME: string;
  APP_VERSION: string;
  /**
   * When true, every service returns in-repo mock data and the app issues no
   * HTTP requests. This is the ONLY switch between mock and real APIs --
   * see niraxobid.md section 22.
   */
  ENABLE_MOCKS: boolean;
  LOG_LEVEL: LogLevel;
}

const LOG_LEVELS: readonly LogLevel[] = ['error', 'warn', 'info', 'debug'];

function readLogLevel(raw: string | undefined): LogLevel {
  return LOG_LEVELS.find((level) => level === raw) ?? 'info';
}

export const env: Env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'NiraxoBID',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  ENABLE_MOCKS: import.meta.env.VITE_ENABLE_MOCKS === 'true',
  LOG_LEVEL: readLogLevel(import.meta.env.VITE_LOG_LEVEL),
};
